(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diggn-national-day-96-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeChooser(root) {
      if (!root || root.dataset.nd96ChooserReady === 'true') return;
      var form = root.querySelector('[data-nd96-form]');
      if (!form) return;

      var variantsNode = form.querySelector('[data-nd96-kit-variants]');
      var kitId = form.querySelector('[data-nd96-kit-id]');
      var bagInputs = Array.prototype.slice.call(form.querySelectorAll('[data-nd96-bag]'));
      var kitScentButtons = Array.prototype.slice.call(form.querySelectorAll('[data-nd96-scent-option="kit"]'));
      var giftScentButtons = Array.prototype.slice.call(form.querySelectorAll('[data-nd96-scent-option="gift"]'));
      var giftValue = form.querySelector('[data-nd96-gift-value]');
      var giftId = form.querySelector('[data-nd96-gift-id]');
      var selectionImage = form.querySelector('[data-nd96-selection-image]');
      var selectionScent = form.querySelector('[data-nd96-selection-scent]');
      var selectionBag = form.querySelector('[data-nd96-selection-bag]');
      var selectionGift = form.querySelector('[data-nd96-selection-gift]');
      var selectionError = form.querySelector('[data-nd96-selection-error]');
      var cartError = form.querySelector('[data-nd96-cart-error]');
      var offerUnavailable = form.querySelector('[data-nd96-offer-unavailable]');
      var submitButton = form.querySelector('[data-nd96-submit]');
      var discountCode = root.dataset.nd96DiscountCode || '';
      var variants = [];
      var busy = false;
      var existingOffer = root.querySelector('[data-nd96-existing]');
      var buyBar = root.querySelector('[data-nd96-buy-bar]');
      var barAction = root.querySelector('[data-nd96-bar-action]');
      var steps = Array.prototype.slice.call(form.querySelectorAll('[data-nd96-step]'));

      function openStep(name) {
        steps.forEach(function (step) { step.open = step.dataset.nd96Step === name; });
      }
      function updateSummaries() {
        ['kit', 'bag', 'gift'].forEach(function (name) {
          var summary = form.querySelector('[data-nd96-step-value="' + name + '"]');
          var source = name === 'kit' ? selectionScent : name === 'bag' ? selectionBag : selectionGift;
          if (summary && source) summary.textContent = source.textContent;
        });
        if (barAction) barAction.textContent = giftId && giftId.value ? barAction.dataset.addLabel : barAction.dataset.chooseLabel;
      }
      function showExisting(cart, focus) {
        if (!existingOffer) return;
        existingOffer.hidden = !cartHasNationalDayOffer(cart);
        if (!existingOffer.hidden && focus) {
          existingOffer.scrollIntoView({ block: 'center' });
          var link = existingOffer.querySelector('a');
          if (link) link.focus({ preventScroll: true });
        }
      }
      function trackConfirmedAdd(snapshot) {
        try {
          var privacy = window.Shopify && window.Shopify.customerPrivacy;
          if (!privacy || !privacy.analyticsProcessingAllowed()) return;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'national_day_96_add_confirmed', kit_variant_id: snapshot.kit, gift_variant_id: snapshot.gift });
        } catch (error) { /* Analytics must never interrupt a cart operation. */ }
      }


      try {
        variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]');
      } catch (error) {
        return;
      }

      if (!variants.length || !kitId) return;
      root.dataset.nd96ChooserReady = 'true';

      var currentVariant = variants.find(function (variant) {
        return String(variant.id) === String(kitId.value);
      }) || variants.find(function (variant) {
        return variant.available;
      });
      var selectedScent = currentVariant ? currentVariant.option1 : '';
      var selectedBag = currentVariant ? currentVariant.option2 : '';

      function setButtonSelection(buttons, value) {
        buttons.forEach(function (button) {
          var selected = button.dataset.value === value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-checked', selected ? 'true' : 'false');
          button.tabIndex = selected ? 0 : -1;
        });
        if (!buttons.some(function (button) { return button.tabIndex === 0 && !button.disabled; })) {
          var first = buttons.find(function (button) { return !button.disabled; });
          if (first) first.tabIndex = 0;
        }
      }

      function hideErrors() {
        if (selectionError) selectionError.hidden = true;
        if (cartError) cartError.hidden = true;
        if (offerUnavailable) offerUnavailable.hidden = true;
      }

      function cartEndpoint(path) {
        var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
        return routeRoot + path;
      }

      function requestCart(path, body) {
        return fetch(cartEndpoint(path), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }).then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            if (!response.ok) {
              var message = payload.description || payload.message || 'Cart request failed';
              throw new Error(message);
            }
            return payload;
          });
        });
      }

      function readCart() {
        return fetch(cartEndpoint('cart.js'), {
          method: 'GET',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        });
      }

      function setSubmitting(isSubmitting) {
        busy = isSubmitting;
        form.setAttribute('aria-busy', String(isSubmitting));
        Array.prototype.forEach.call(form.querySelectorAll('button, input'), function (control) {
          if (isSubmitting) {
            control.dataset.nd96WasDisabled = String(control.disabled);
            control.disabled = true;
          } else if (control.dataset.nd96WasDisabled !== undefined) {
            control.disabled = control.dataset.nd96WasDisabled === 'true';
            delete control.dataset.nd96WasDisabled;
          }
        });
        if (barAction) barAction.disabled = isSubmitting;
        if (!submitButton) return;
        if (!submitButton.dataset.defaultLabel) {
          submitButton.dataset.defaultLabel = submitButton.textContent.trim();
        }
        submitButton.disabled = isSubmitting;
        submitButton.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
        submitButton.textContent = isSubmitting
          ? submitButton.dataset.loadingLabel
          : submitButton.dataset.defaultLabel;
      }

      function removeAddedLines(items) {
        var keys = (items || []).map(function (item) { return item.key; }).filter(Boolean);
        return keys.reduce(function (promise, key) {
          return promise.then(function () {
            return requestCart('cart/change.js', { id: key, quantity: 0 });
          });
        }, Promise.resolve());
      }

      function cartDiscountCodes(cart) {
        return (cart && cart.discount_codes || []).map(function (discount) {
          return discount.code;
        }).filter(Boolean);
      }

      function cartHasNationalDayOffer(cart) {
        return (cart && cart.items || []).some(function (item) {
          var properties = item.properties || {};
          return properties._nd96_offer === 'saudi-national-day-96-2026';
        });
      }

      function restoreDiscountCodes(codes) {
        return requestCart('cart/update.js', { discount: (codes || []).join(',') });
      }

      function discountAppliedToGift(cart, pairId, selectedGiftId) {
        var codeApplied = (cart.discount_codes || []).some(function (discount) {
          return String(discount.code || '').toUpperCase() === discountCode.toUpperCase() && discount.applicable === true;
        });
        var giftLine = (cart.items || []).find(function (item) {
          var properties = item.properties || {};
          return String(item.variant_id) === String(selectedGiftId)
            && properties._nd96_pair_id === pairId
            && properties._nd96_role === 'gift';
        });
        var giftIsFree = giftLine && Number(giftLine.final_line_price) === 0;
        return codeApplied && giftIsFree;
      }

      function addOfferToCart() {
        if (busy) return;
        if (!giftId || !giftId.value) {
          openStep('gift');
          if (selectionError) selectionError.hidden = false;
          var firstGift = giftScentButtons.find(function (button) {
            return !button.disabled;
          });
          if (firstGift) firstGift.focus({ preventScroll: false });
          return;
        }

        hideErrors();
        var snapshot = { kit: kitId.value, gift: giftId.value, giftDisplay: giftValue ? giftValue.value : '' };
        setSubmitting(true);

        var pairId = 'nd96-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
        var kitProperties = {
          '_nd96_offer': 'saudi-national-day-96-2026',
          '_nd96_pair_id': pairId,
          '_nd96_role': 'qualifying-kit',
          '_nd96_gift_variant_id': snapshot.gift,
          '_nd96_gift_display': snapshot.giftDisplay
        };
        var giftProperties = {
          '_nd96_offer': 'saudi-national-day-96-2026',
          '_nd96_pair_id': pairId,
          '_nd96_role': 'gift',
          '_nd96_gift_display': snapshot.giftDisplay
        };
        var addedItems = [];
        var previousDiscountCodes = [];

        readCart().then(function (cart) {
          previousDiscountCodes = cartDiscountCodes(cart);
          if (cartHasNationalDayOffer(cart)) {
            showExisting(cart, true);
            var existingOfferError = new Error('National Day offer is already in the cart');
            existingOfferError.offerAlreadyInCart = true;
            throw existingOfferError;
          }
          return requestCart('cart/add.js', {
            items: [
              { id: Number(snapshot.kit), quantity: 1, properties: kitProperties },
              { id: Number(snapshot.gift), quantity: 1, properties: giftProperties }
            ]
          });
        }).then(function (addResult) {
          addedItems = addResult.items || [];
          return requestCart('cart/update.js', { discount: discountCode });
        }).then(function (cart) {
          if (!discountAppliedToGift(cart, pairId, snapshot.gift)) {
            return removeAddedLines(addedItems).then(function () {
              addedItems = [];
              return restoreDiscountCodes(previousDiscountCodes);
            }).then(function () {
              var unavailableError = new Error('National Day gift is unavailable');
              unavailableError.offerUnavailable = true;
              throw unavailableError;
            });
          }
          trackConfirmedAdd(snapshot);
          window.location.assign(cartEndpoint('cart'));
        }).catch(function (error) {
          var cleanup = addedItems.length
            ? removeAddedLines(addedItems).then(function () {
                return restoreDiscountCodes(previousDiscountCodes);
              }).catch(function () {})
            : Promise.resolve();
          cleanup.then(function () {
            if (error && error.offerAlreadyInCart) {
              setSubmitting(false);
              return;
            } else if (error && error.offerUnavailable) {
              if (offerUnavailable) offerUnavailable.hidden = false;
            } else if (cartError) {
              cartError.hidden = false;
            }
            setSubmitting(false);
          });
        });
      }

      function displayValue(buttons, value) {
        var button = buttons.find(function (candidate) {
          return candidate.dataset.value === value;
        });
        return button ? button.dataset.displayValue || value : value;
      }

      function findVariant(scent, bag) {
        return variants.find(function (variant) {
          return variant.available && variant.option1 === scent && variant.option2 === bag;
        });
      }

      function updateBagAvailability() {
        bagInputs.forEach(function (input) {
          var available = Boolean(findVariant(selectedScent, input.value));
          input.disabled = !available;
          input.classList.toggle('disabled', !available);
          if (!available && input.checked) input.checked = false;
        });
      }

      function updateKitSelection() {
        var variant = findVariant(selectedScent, selectedBag);
        if (!variant) {
          variant = variants.find(function (candidate) {
            return candidate.available && candidate.option1 === selectedScent;
          });
          if (!variant) return;
          selectedBag = variant.option2;
        }

        kitId.value = variant.id;
        setButtonSelection(kitScentButtons, selectedScent);
        bagInputs.forEach(function (input) {
          input.checked = input.value === selectedBag;
        });
        updateBagAvailability();

        if (selectionScent) selectionScent.textContent = displayValue(kitScentButtons, selectedScent);
        if (selectionBag) selectionBag.textContent = selectedBag;
        if (selectionImage && variant.image) selectionImage.src = variant.image;
        updateSummaries();
      }

      kitScentButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (busy || button.disabled) return;
          selectedScent = button.dataset.value;
          updateKitSelection();
        });
      });

      bagInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (busy || !input.checked || input.disabled) return;
          selectedBag = input.value;
          updateKitSelection();
        });
      });

      giftScentButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (busy || button.disabled) return;
          setButtonSelection(giftScentButtons, button.dataset.value);
          if (giftValue) giftValue.value = button.dataset.displayValue || button.dataset.value;
          if (giftId) giftId.value = button.dataset.variantId || '';
          if (selectionGift) selectionGift.textContent = button.dataset.displayValue || button.dataset.value;
          hideErrors();
          updateSummaries();
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addOfferToCart();
      });
      if (submitButton) submitButton.addEventListener('click', addOfferToCart);

      [kitScentButtons, giftScentButtons].forEach(function (buttons) {
        buttons.forEach(function (button) {
          button.addEventListener('keydown', function (event) {
            if (busy || ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) < 0) return;
            var enabled = buttons.filter(function (item) { return !item.disabled; });
            if (!enabled.length) return;
            event.preventDefault();
            var rtl = getComputedStyle(root).direction === 'rtl';
            var forward = event.key === 'ArrowDown' || (event.key === 'ArrowRight' && !rtl) || (event.key === 'ArrowLeft' && rtl);
            var index = event.key === 'Home' ? 0 : event.key === 'End' ? enabled.length - 1 : (enabled.indexOf(button) + (forward ? 1 : -1) + enabled.length) % enabled.length;
            enabled[index].click();
            enabled[index].focus();
          });
        });
      });
      steps.forEach(function (step) {
        step.querySelector('summary').addEventListener('click', function (event) { if (busy) event.preventDefault(); });
      });
      Array.prototype.forEach.call(form.querySelectorAll('[data-nd96-next]'), function (button) {
        button.addEventListener('click', function () {
          if (busy) return;
          openStep(button.dataset.nd96Next);
          var next = form.querySelector('[data-nd96-step="' + button.dataset.nd96Next + '"] summary');
          if (next) next.focus();
        });
      });
      if (barAction) barAction.addEventListener('click', addOfferToCart);
      if (buyBar && 'IntersectionObserver' in window) {
        var heroPassed = false;
        var actionVisible = false;
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target === submitButton) actionVisible = entry.isIntersecting;
            else heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          });
          buyBar.hidden = !heroPassed || actionVisible;
        });
        var hero = root.querySelector('.nd96-landing__hero');
        if (hero) observer.observe(hero);
        if (submitButton) observer.observe(submitButton);
      }
      setButtonSelection(giftScentButtons, '');
      updateKitSelection();
      readCart().then(function (cart) { showExisting(cart, false); }).catch(function () {});
    }

    function start(scope) {
      var roots = scope && scope.matches && scope.matches('[data-nd96-landing]')
        ? [scope]
        : document.querySelectorAll('[data-nd96-landing]');
      Array.prototype.forEach.call(roots, initializeChooser);
    }

    start(document);
    document.addEventListener('shopify:section:load', function (event) {
      start(event.target);
    });
  })();

  (function () {
    function initialize(root) {
      if (!root || root.dataset.nd96MotionReady === 'true') return;
      root.dataset.nd96MotionReady = 'true';

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var saveData = Boolean(navigator.connection && navigator.connection.saveData);
      if (reducedMotion || saveData) return;

      var hero = root.querySelector('.nd96-landing__hero');
      if (!hero) return;

      root.classList.add('nd96-landing--motion-ready');
      var active = true;
      var animationFrame = 0;
      var startY = 0;
      var travel = 1;

      function clamp(value) {
        return Math.min(1, Math.max(0, value));
      }

      function measure() {
        var rect = hero.getBoundingClientRect();
        var documentTop = rect.top + window.scrollY;
        startY = Math.max(0, documentTop - Math.min(documentTop, window.innerHeight * 0.22));
        travel = Math.max(hero.offsetHeight * 0.62, 1);
      }

      function update() {
        animationFrame = 0;
        var progress = clamp((window.scrollY - startY) / travel);
        var burstPhase = clamp((progress - 0.04) / 0.58);
        var sparkPhase = clamp((progress - 0.01) / 0.72);
        var lightPhase = clamp(progress / 0.82);
        var burst = Math.sin(Math.PI * burstPhase);
        var sparks = Math.sin(Math.PI * sparkPhase) * 0.72;
        var light = Math.sin(Math.PI * lightPhase) * 0.55;

        root.style.setProperty('--nd96-burst-distance', (-1.4 - burst * 4.2).toFixed(2) + 'rem');
        root.style.setProperty('--nd96-burst-opacity', (burst * 0.84).toFixed(3));
        root.style.setProperty('--nd96-burst-ray-scale', (0.25 + burst * 0.75).toFixed(3));
        root.style.setProperty('--nd96-burst-scale', (0.55 + burst * 0.55).toFixed(3));
        root.style.setProperty('--nd96-hero-content-shift', (progress * -18).toFixed(2) + 'px');
        root.style.setProperty('--nd96-hero-light-opacity', light.toFixed(3));
        root.style.setProperty('--nd96-hero-media-scale', (1 + progress * 0.025).toFixed(4));
        root.style.setProperty('--nd96-hero-media-shift', (progress * -18).toFixed(2) + 'px');
        root.style.setProperty('--nd96-spark-opacity', sparks.toFixed(3));
        root.style.setProperty('--nd96-spark-scale', (0.55 + sparks * 0.75).toFixed(3));
      }

      function scheduleUpdate() {
        if (!active || animationFrame) return;
        animationFrame = window.requestAnimationFrame(update);
      }

      measure();
      update();

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          active = entries[0].isIntersecting;
          if (active) scheduleUpdate();
        }, { rootMargin: '15% 0px' });
        observer.observe(hero);
      }

      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', function () {
        measure();
        scheduleUpdate();
      }, { passive: true });
    }

    function start(scope) {
      var roots = scope && scope.matches && scope.matches('[data-nd96-landing]')
        ? [scope]
        : document.querySelectorAll('[data-nd96-landing]');
      Array.prototype.forEach.call(roots, initialize);
    }

    start(document);
    document.addEventListener('shopify:section:load', function (event) {
      start(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
